import React from 'react'
import styled from 'styled-components'

import DesktopGrandAwardItem from './desktop/GrandAwardItem'
import DesktopAwardItem from './desktop/AwardItem'
import MobileGrandAwardItem from './mobile/GrandAwardItem'
import MobileAwardItem from './mobile/AwardItem'
import { MysqlRanksEdge, MysqlSurveyQuestionsEdge } from '../../graphqlTypes'

const Container = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  list-style: none;
`

const DesktopContainer = styled(Container)`
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const MobileContainer = styled(Container)`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

type Props = {
  ranks: MysqlRanksEdge[]
  surveyQuestions: MysqlSurveyQuestionsEdge[]
}

export default function Ranking({ ranks, surveyQuestions }: Props) {
  const items = ranks.length < 3 ? [ranks[0]] : ranks

  return (
    <React.Fragment>
      <DesktopContainer>
        {items.map((item: MysqlRanksEdge) => {
          const isGrandAward = item.node.rank === 1 ? 1 : null
          if (isGrandAward) {
            return <DesktopGrandAwardItem key={item.node.id} rank={item} surveyQuestions={surveyQuestions} />
          } else {
            return <DesktopAwardItem key={item.node.id} rank={item} />
          }
        })}
      </DesktopContainer>
      <MobileContainer>
        {items.map((item: MysqlRanksEdge) => {
          const isGrandAward = item.node.rank === 1 ? 1 : null
          if (isGrandAward) {
            return <MobileGrandAwardItem key={item.node.id} rank={item.node} />
          } else {
            return <MobileAwardItem key={item.node.id} rank={item.node} />
          }
        })}
      </MobileContainer>
    </React.Fragment>
  )
}
